<template>
  <div>

    <div style="padding-top: 20px;">
      <div style="" class="logoImg">

      </div>
      <div style="padding-left: 300px;font-size: 32px;letter-spacing: 2.67px;color: white;margin-top: 25px;font-weight: 100">点春官网后台管理系统</div>
      <div style="float: right;    padding-right: 36px;">
        <p
          style="color: white;padding: 0px;cursor: pointer;margin-top: -15px;"
          @click="loginOut"> 退出
        </p>
      </div>
    </div>

  </div>
</template>

<script>

function loginOut() {
  this.$router.push({
    path: '/',

  });
}

export default {
  name: 'TouchHeader',

  data() {
    return {
    };
  },
  methods: {
    loginOut,
  },
};

</script>

<style scoped>


  .logoImg {
    height: 20px;
    width: 176px;
    float: left;
    margin-left: 62px;
    background-size: 100% 100%;
    background-image: url("../assets/bLOGO.png");
  }


</style>
